export const checkIsCodeFull = (code: string[] | null) => {
  return code ? code.every((digit) => digit !== "") : false;
};
